import React from 'react';
import {Card, CardActions, CardTitle, CardText} from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import PasswordReset from './PasswordReset';
import Snackbar from 'material-ui/Snackbar';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      email: '',
      password: '',
      errorMessage: '',
      emailErrorText: '',
      passwordErrorText: '',
      passwordResetDialogOpen: false,
      passwordResetSnackbar: false
    };
    this.state = {
      ...this.initialState
    };
  }
  handleEmailChange = (event, email) => {
    this.setState({emailErrorText: '', email});
  }
  handlePasswordChange = (event, password) => {
    this.setState({passwordErrorText: '', password});
  }
  handleLoginError = (error) => {
    const {t} = this.props;
    if (error) {
      this.setState({errorMessage: t('Loginfail')});
    }
  }
  handleLogin = (event) => {
    event.preventDefault();
    const validatedEmail = this.validateEmail();
    const validatedPassword = this.validatePassword();
    if (validatedEmail && validatedPassword) {
      this.props.firebase.auth()
      .signInWithEmailAndPassword(this.state.email, this.state.password)
      .catch(this.handleLoginError);
    }
  }
  validateEmailwithRegex = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  validateEmail = () => {
    const {t} = this.props;
    if(this.state.email) {
      if (!this.validateEmailwithRegex(this.state.email)) {
        this.setState({emailErrorText:t('invalid')});
        return false;
      } else {
        return true;
      }
    } else {
      this.setState({emailErrorText:t('required')});
      return false;
    }
  }
  validatePassword = () => {
    const {t} = this.props;
    if(!this.state.password) {
      this.setState({passwordErrorText: t('required')});
      return false;
    } else {
      return true;
    }
  }
  handlePasswordResetDialogOpen = () => {
    this.setState({passwordResetDialogOpen: true});
  }
  handlePasswordResetDialogClose = () => {
    this.setState({passwordResetDialogOpen: false});
  }

  openPasswordResetSnackbar = () => {this.setState({passwordResetSnackbar: true});}
  closePasswordResetSnackbar = () => {this.setState({passwordResetSnackbar: false});}

  render() {
    const {t} = this.props;

    return (
      <center>
        <Card style={{
          maxWidth: '500px',
          marginTop: '20vh'
        }}>
        <CardTitle
          title={t('login')}
        />
        <form onSubmit={this.handleLogin}>
          <TextField hintText={t('email')}
            floatingLabelText={t('email')}
            errorText={this.state.emailErrorText}
            onChange={this.handleEmailChange}
            onBlur={this.validateEmail}
          />
          <br />
          <TextField hintText={t('password')}
            floatingLabelText={t('password')}
            type="password"
            errorText={this.state.passwordErrorText}
            onChange={this.handlePasswordChange}
            onBlur={this.validatePassword}
          />
          <CardText style={{
            color: '#F44336',
          }}>{this.state.errorMessage}
        </CardText>
        <CardActions>
          <RaisedButton style={{marginBottom: '2vh'}} label={t('login')} primary={true} type="submit"/>
          <Divider/>
          <FlatButton style={{marginTop: '2vh'}} label={t('forgotPassword')} primary={true} onTouchTap={this.handlePasswordResetDialogOpen}/>
        </CardActions>
      </form>

      <Snackbar
        open={this.state.passwordResetSnackbar}
        message={t('resetPasswordEmail')}
        autoHideDuration={4000}
        onRequestClose={this.closePasswordResetSnackbar}
      />
      <PasswordReset email={this.state.email} handleClose={this.handlePasswordResetDialogClose} open={this.state.passwordResetDialogOpen} snackbarOpen={this.openPasswordResetSnackbar}/>
    </Card>
  </center>
    );
  }
}

export default translate()(firebase(Login));



// WEBPACK FOOTER //
// ./src/Auth/Login.js